import { render, staticRenderFns } from "./WiseSelectAccount.vue?vue&type=template&id=33b372e3&"
import script from "./WiseSelectAccount.vue?vue&type=script&lang=js&"
export * from "./WiseSelectAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports